import imagesLoaded from 'imagesloaded/imagesloaded.js'
window.imagesLoaded = imagesLoaded
